import { render, staticRenderFns } from "./iButtonList.vue?vue&type=template&id=960adcb0&scoped=true&"
import script from "./iButtonList.vue?vue&type=script&lang=js&"
export * from "./iButtonList.vue?vue&type=script&lang=js&"
import style0 from "./iButtonList.vue?vue&type=style&index=0&id=960adcb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960adcb0",
  null
  
)

export default component.exports